import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Endpoints } from '@shared/Endpoints';
import { Observable, of, zip } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoadingService, TLoadingItem } from './loading.service';

@Injectable()
export class MomentumService {
  constructor(
    private _loadingService: LoadingService,
    private _http: HttpClient
  ) {}


  /**
   * Compute Momentum with callback, legacy version
   * @param  {number[]} values
   * @param  {(res:number[])=>void} callback?
   * @returns void
   */
  public computeMomentum(values: number[], callback?: (res: number[]) => void): void {
    const response = this.computeMomentumRequest$(values);
    response.subscribe({
      next: (response) => {
        if (callback) callback(response);
      },
    });
  }

  /**
   * Compute Momentum, the Angular way
   * @param  {number[]} values
   * @returns Observable
   */
  public computeMomentumRequest$(values: number[]): Observable<number[]> {
    return of([]).pipe(
      map(() => {
        // adding loadingItem inside a pipe prevents showing loading indicator before subscription
        const loadingItem: TLoadingItem = this._loadingService.buildLoadingItem(`Computing momentum`);
        this._loadingService.addLoadingItem(loadingItem);
        return loadingItem;
      }),
      switchMap(loadingItem => {
        const url: string = Endpoints.BUILD_URL(`rise`, {
          base: environment.apiUrl,
          endpoint: 'computeMomentum',
          params: '',
        });
        return zip(this._http.post<number[]>(url, { values }), of(loadingItem));
      }),
      tap(([momentum, loadingItem]) => {
        this._loadingService.removeItem(loadingItem);
      }),
      map(([momentum, loadingItem]) => momentum),
      catchError(err => {
        console.error(err);
        this._loadingService.onError();
        return of(err);
      }),
    );
  }

}
